<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card>
          <template slot="actions">
            <!-- <vs-button @click.stop="onClickCreate()">Create</vs-button> -->
          </template>
          <div slot="no-body" class="mt-4">
            <vs-table pagination max-items="10" :data="partner_agreement_list" @sort="handleSort" stripe
              class="table-dark-inverted table-auto vs-con-loading__container">>

              <template slot="thead">
                <vs-th>CHANNEL PARTNER AGREEMENT CODE</vs-th>
                <vs-th>DATE INTRODUCED</vs-th>
                <vs-th>AGREEMENT START DATE</vs-th>
                <vs-th>AGREEMENT END DATE</vs-th>
                <vs-th>PERCENTAGE (%)</vs-th>
                <vs-th>STATUS</vs-th>
                <vs-th>CREATED AT</vs-th>
                <vs-th>ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr class="cursor-pointer" :key="indextr"
                  v-for="(tr, indextr) in data">


                  <vs-td :data="data[indextr].code">
                    {{ data[indextr].code }}
                  </vs-td>
                  <vs-td :data="data[indextr].date_introduced">
                    {{ data[indextr].date_introduced }}
                  </vs-td>
                  <vs-td :data="data[indextr].start_date">
                    {{ data[indextr].start_date }}
                  </vs-td>
                  <vs-td :data="data[indextr].end_date">
                    {{ data[indextr].end_date }}
                  </vs-td>
                  <vs-td :data="data[indextr].percent">
                    {{ data[indextr].percent }}
                  </vs-td>
                  <vs-td :data="data[indextr].is_approved">
                    {{ data[indextr].status }}
                  </vs-td>
                  <vs-td>
                    {{ __dateTimeFormatter(data[indextr].created_at) }}
                  </vs-td>

                  <vs-td>
                    <!-- <div class="vx-row">
                      <vx-tooltip text="View" position="left">
                        <vs-button class="ml-3" @click="onClickViewManufacturing(data[indextr].id)" size="small"
                          color="primary" type="border" icon-pack="feather" icon="icon-eye"></vs-button>
                      </vx-tooltip>
                    </div> -->
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>

          </div>
        </vx-card>
      </div>
    </div>
    <CreateChannelPartnerAgreementPopUp ref="createChannelPartnerAgreementPopUp"/>
  </div>
</template>

<script>

import { RepositoryFactory } from '@/repository/RepositoryFactory'
import Filter from '@/mixins/filter';
const SupplierRepository = RepositoryFactory.get('supplier');
const ChannelPartnerRepository = RepositoryFactory.get('channel_partner')
import CreateChannelPartnerAgreementPopUp from '@/components/popups/tenants/channel-partners/CreateChannelPartnerAgreementPopUp.vue'

export default {
  name: 'ChannelPartnerCustomerList',
  data() {
    return {
      partner_agreement_list: [],
      filters: {},
      page: 1,
      total: 0,
      meta: {},
      sort: '',
      supplierId: ''
    }
  },
  components: {
    CreateChannelPartnerAgreementPopUp
  },
  props: {
    tenant_id: {
      required: true,
      default: ''
    },
    partner_id: {
      required: true,
      default: ''
    }
  },
  mixins: [Filter],
  async mounted() {
    // this.$refs.filterCard.isContentCollapsed = true
    // this.$refs.filterCard.maxHeight = '1.5rem'
  },
  methods: {
    async refreshData() {
      this.fetchManufacturingSites()
    },

    async fetchManufacturingSites() {
      this.$vs.loading()
      const { data } = await ChannelPartnerRepository.getChannelPartnerCustomers(this.partner_id, this.page, 20, this.tenant_id)
      this.partner_agreement_list = data.data
      this.meta = data.meta
      this.$vs.loading.close()
    },
    onClickViewManufacturing(id) {
      this.$router.push({ path: `/pages/manage-app/suppliers/${this.partner_id}/manufacturing/${id}` })
    },
    filterQueryUpdate() {
      this.fetchManufacturingSites()
    },
    handleChangePage(page) {
      this.page = page;
      this.fetchManufacturingSites()
    },

    handleSort(key, active) {
      if (key) {
        active = (active === 'desc') ? "-" : '';
        this.sort = active + key;
        this.fetchManufacturingSites()
      }

    },
    onClickCreate() {
      this.$refs.createChannelPartnerAgreementPopUp.openPopup()
    }

  },
}
</script>


<style scoped></style>
